import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64150e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receivers-container" }
const _hoisted_2 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_3 = {
  class: "col text-wrap text-truncate",
  "data-test": "receiver-details-heading"
}
const _hoisted_4 = { class: "col-auto ms-auto align-self-end align-self-sm-start" }
const _hoisted_5 = { class: "mt-sm-0 d-flex col-sm-auto mt-2 col-12 col-sm-auto" }
const _hoisted_6 = { class: "mb-2 mb-sm-0 mx-sm-2" }
const _hoisted_7 = { class: "ms-auto" }
const _hoisted_8 = {
  key: 0,
  class: "row float-right text-danger"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "float-right",
  style: {"padding":"0","margin":"0"}
}, "Legacy receivers are no longer supported.", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "dt-container"
}
const _hoisted_12 = { class: "dt-container dt-container--tabbed" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-name-heading" }, "Receiver Name", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-name-text" }, "Enter a name for the receiver. Example: Conference Room 1B Ditto Receiver", -1))
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-platform-heading" }, "Platform", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-platform-text" }, "What connection type does this receiver use?", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  class: "text-left disclaimer row col-xs-12",
  "data-test": "receiver-details-last-version-text"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-network-info-heading" }, "Network Info", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-static-ip-switch-description" }, "Enforce static IP address", -1))
const _hoisted_27 = {
  key: 1,
  "data-test": "receiver-details-static-ip-text"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-enter-network-info-text" }, "Enter network information for this receiver.", -1))
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-network-info-deployment-text" }, "Network information for this receiver will appear after you finish deployment.", -1))
const _hoisted_31 = { key: 4 }
const _hoisted_32 = {
  class: "text-left disclaimer row col-xs-12",
  "data-test": "receiver-details-last-ip-address-text"
}
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = {
  key: 0,
  class: "el-form-item__label",
  "data-test": "receiver-details-active-room-heading"
}
const _hoisted_35 = {
  key: 1,
  class: "el-form-item__label",
  "data-test": "receiver-details-add-to-room-heading"
}
const _hoisted_36 = {
  key: 0,
  "data-test": "receiver-details-active-room-description"
}
const _hoisted_37 = {
  key: 1,
  "data-test": "receiver-details-active-room-description"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-active-room-text" }, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Note:"),
    /*#__PURE__*/_createTextVNode(" A legacy receiver cannot be linked with any other receivers, including other legacy receivers.")
  ])
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-add-to-room-text" }, "Upgrade your Ditto account to link additional rooms and receivers.", -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter a note for the receiver.", -1))
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { "data-test": "receiver-details-geenral-heading" }, "General", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-details-general-description" }, "Manage the general settings for this Ditto Receiver.", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-disable-screensaver-switch-text" }, "Disable Screensaver", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-general-text" }, "Check this box to prevent the receiver’s screensaver from overriding Ditto.", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-screen-dimming-heading" }, "Screen Dimming", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-dimming-text" }, "How much the screen should dim when a receiver is idle.", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-display-fullscreen-switch-text" }, "Display Fullscreen", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-display-fullscreen-switch-description" }, "Choose if Ditto Receiver launches in fullscreen mode or in a smaller, windowed mode (good for receivers that are used for other things like video conferencing)", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-launch-login-switch-text" }, "Launch at Login", -1))
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-security-heading" }, "Security", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-onscreen-code-description" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("em", null, "Onscreen code:")
  ]),
  /*#__PURE__*/_createTextVNode(" a code is required each time a device connects to this receiver.")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-onetime-code-description" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("em", null, "One-time onscreen code:")
  ]),
  /*#__PURE__*/_createTextVNode(" a code is required the first time a device connects to this receiver.")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-security-code-position-heading" }, "Security Code Position", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-code-position-text" }, "Select where the on-screen security code appears for this receiver", -1))
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { "data-test": "receiver-details-security-advanced-heading" }, "Advanced", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-details-security-advanced-text" }, "These advanced options are best left at their default values. The Ditto Support team may have you change these if you’re experiencing any issues with Ditto.", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-details-logging-level-heading" }, "Logging Level", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Use Classic Renderer", -1))
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Connections", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allow AirPlay Connections", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allow Cast Connections", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allow Miracast Connections", -1))
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}, " Click here to learn more. ", -1))
const _hoisted_75 = {
  key: 0,
  "data-test": "receiver-details-status-text"
}
const _hoisted_76 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_77 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "primary-color",
          to: "/receivers",
          "data-test": "receiver-details-back-to-list-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Receivers")
          ]),
          _: 1
        }),
        _createTextVNode(" » " + _toDisplayString(_ctx.receiver.displayName), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _ctx.onCancel,
          "data-test": "receiver-details-cancel-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            disabled: _ctx.saving,
            type: "danger",
            onClick: _ctx.onDelete,
            "data-test": "receiver-details-delete-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete Receiver")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            disabled: _ctx.saving || (!_ctx.isSSP && !_ctx.legacyReceiversEnabled),
            type: "primary",
            onClick: _ctx.onSave,
            "data-test": "receiver-details-save-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save Receiver")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    (!_ctx.viewLoading && (!_ctx.isSSP && !_ctx.legacyReceiversEnabled))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    (!_ctx.canActivateReceivers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: _ctx.tierLimitReachedMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.activeTab) = $event)),
        onTabClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Overview",
            name: "overview"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "hide-required-asterisk": "",
                ref: "form",
                rules: _ctx.rules,
                "label-position": "top",
                model: _ctx.receiver,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_form_item, {
                        label: "Receiver Name",
                        prop: "displayName",
                        "data-test": "receiver-details-name-form"
                      }, {
                        label: _withCtx(() => [
                          _hoisted_15
                        ]),
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.receiver.displayName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.receiver.displayName) = $event)),
                            placeholder: "Receiver Name",
                            "data-test": "receiver-details-name-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_form_item, {
                        label: "Receiver Platform",
                        "data-test": "receiver-details-platform-form"
                      }, {
                        label: _withCtx(() => [
                          _hoisted_18
                        ]),
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.receiver.platform,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.receiver.platform) = $event)),
                            disabled: "",
                            "data-test": "receiver-details-platform-dropdown"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "atvlegacy",
                                label: "ATV 2/3 (AirPlay)"
                              }),
                              _createVNode(_component_el_option, {
                                value: "chromecast",
                                label: "Chromecast (Cast)"
                              }),
                              (_ctx.receiver.deviceType == 'AirPlay')
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 0,
                                    value: "other",
                                    label: "Other (AirPlay)"
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.receiver.deviceType == 'Cast')
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 1,
                                    value: "other",
                                    label: "Other (Cast)"
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.isSSP)
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 2,
                                    value: "windows",
                                    label: "Windows (Ditto Receiver)"
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.isSSP)
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 3,
                                    value: "tvos",
                                    label: "tvOS (Ditto Receiver)"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (_ctx.receiver && _ctx.receiver.lastKnownVersion)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, "Last Known Version: " + _toDisplayString(_ctx.receiver.lastKnownVersion), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_form_item, {
                        label: "Network Information",
                        "data-test": "receiver-details-network-info-form"
                      }, {
                        label: _withCtx(() => [
                          _hoisted_24
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isSSP && !(_ctx.pairing && !_ctx.pairing.isUsed))
                            ? (_openBlock(), _createElementBlock("label", _hoisted_25, [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.receiver.manualIpAddressOverride,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.receiver.manualIpAddressOverride) = $event)),
                                  "data-test": "receiver-details-static-ip-switch"
                                }, null, 8, ["modelValue"]),
                                _hoisted_26
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isSSP && !(_ctx.pairing && !_ctx.pairing.isUsed))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Ditto Connect will use the static IP address when connecting to this receiver."))
                            : _createCommentVNode("", true),
                          (_ctx.receiver.manualIpAddressOverride || !_ctx.isSSP && _ctx.receiver.manualIpAddresses)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_28,
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.receiver.manualIpAddresses[0],
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.receiver.manualIpAddresses[0]) = $event)),
                                    class: "me-2",
                                    placeholder: "IP Address",
                                    "data-test": "receiver-details-manual-ip-address-input"
                                  }, null, 8, ["modelValue"]),
                                  (!_ctx.isPlatform('tvos'))
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: _ctx.receiver.identifiers.mac,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receiver.identifiers.mac) = $event)),
                                        placeholder: "MAC Address",
                                        "data-test": "receiver-details-manual-mac-address-input"
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 64))
                            : (_ctx.pairing && !_ctx.pairing.isUsed)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _hoisted_30,
                                  (_ctx.pairing && !_ctx.pairing.isUsed)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        onClick: _ctx.generatePairingRegistryKey,
                                        "data-test": "receiver-details-generate-pairing-key-button"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Generate Pairing Registry Key")
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                          (_ctx.receiver && _ctx.receiver.lastKnownIpAddress)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, "Last Known IP Address: " + _toDisplayString(_ctx.receiver.lastKnownIpAddress), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (_ctx.unusedRoomCount > 0 || _ctx.unusedRoomCount == 0 && (_ctx.roomToUnLink || _ctx.roomToLink))
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                (_ctx.roomToLink)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Active Room"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_35, "Add to Room")),
                                (_ctx.roomToLink)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 2,
                                      class: "el-form-item__subtitle-link m-0 ms-2",
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onUnlinkRoom && _ctx.onUnlinkRoom(...args))),
                                      "data-test": "receiver-details-remove-from-room-button"
                                    }, " Remove From Room"))
                                  : _createCommentVNode("", true)
                              ]),
                              (!_ctx.roomToLink)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Select an available room to activate this receiver. "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_37, "Select an available room to change the receiver's room association. ")),
                              _hoisted_38,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.roomToLink,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.roomToLink) = $event)),
                                placeholder: _ctx.noRoomsAvailablePlaceholder,
                                disabled: _ctx.saving || _ctx.noRoomsAvailable,
                                filterable: "",
                                clearable: "",
                                onClear: _ctx.onUnlinkRoom,
                                "no-data-text": "No Rooms Available",
                                "value-key": "id",
                                "data-test": "receiver-details-active-rooms-dropdown"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRooms, (room) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: room.id,
                                      label: room.roomName,
                                      value: room
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(room.roomName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "disabled", "onClear"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "Add to Room",
                            "data-test": "receiver-details-add-to-room-form"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_39,
                              _createVNode(_component_el_button, {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (this.$router.push({ path: '/organization/billing' }))),
                                "data-test": "recevier-details-go-to-billing-button"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Go to Billing")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ])), [
                      [_directive_loading, _ctx.saving]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_el_form_item, {
                        label: "Note",
                        prop: "note"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.receiver.note,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receiver.note) = $event)),
                            height: { minRows: 2 },
                            type: "textarea",
                            placeholder: "Receiver Note"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ]),
            _: 1
          }),
          (_ctx.isSSP)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: "Settings",
                name: "settings"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "form",
                    "label-position": "top",
                    model: _ctx.receiver
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _hoisted_46,
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                _createVNode(_component_el_switch, {
                                  modelValue: _ctx.receiver.deviceSettings.general.disableScreensaver,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.receiver.deviceSettings.general.disableScreensaver) = $event)),
                                  "data-test": "receiver-details-disable-screensaver-switch"
                                }, null, 8, ["modelValue"]),
                                _hoisted_47
                              ]),
                              _hoisted_48
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "Screen Dimming" }, {
                            label: _withCtx(() => [
                              _hoisted_49
                            ]),
                            default: _withCtx(() => [
                              _hoisted_50,
                              _createVNode(_component_el_slider, {
                                modelValue: _ctx.receiver.deviceSettings.general.screenDimPercent,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.receiver.deviceSettings.general.screenDimPercent) = $event)),
                                marks: _ctx.marks,
                                class: "slider",
                                "data-test": "receiver-details-dimming-slider"
                              }, null, 8, ["modelValue", "marks"])
                            ]),
                            _: 1
                          }),
                          (_ctx.isPlatform('windows'))
                            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.receiver.deviceSettings.connection.displayFullscreen,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.receiver.deviceSettings.connection.displayFullscreen) = $event)),
                                      "data-test": "receiver-details-display-fullscreen-switch"
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_51
                                  ]),
                                  _hoisted_52
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isPlatform('windows'))
                            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.receiver.deviceSettings.advanced.launchAtLogin,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.receiver.deviceSettings.advanced.launchAtLogin) = $event)),
                                      "data-test": "receiver-details-launch-login-switch"
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_53
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_el_form_item, { label: "Security" }, {
                            label: _withCtx(() => [
                              _hoisted_55
                            ]),
                            default: _withCtx(() => [
                              _hoisted_56,
                              _hoisted_57,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.receiver.deviceSettings.connection.airPlaySecurity,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.receiver.deviceSettings.connection.airPlaySecurity) = $event)),
                                "data-test": "receiver-details-securiity-dropdown"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "none",
                                    label: "None"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "onScreen",
                                    label: "Onscreen Code"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "onScreenOneTime",
                                    label: "One-Time Onscreen Code"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (!(_ctx.receiver.deviceSettings.connection.airPlaySecurity=='none'))
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "Security Code Position"
                              }, {
                                label: _withCtx(() => [
                                  _hoisted_58
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_59,
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.receiver.deviceSettings.general.onScreenCodePosition,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.receiver.deviceSettings.general.onScreenCodePosition) = $event)),
                                    "data-test": "receiver-details-code-position-dropdown"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        value: "center",
                                        label: "Center"
                                      }),
                                      _createVNode(_component_el_option, {
                                        value: "topLeft",
                                        label: "Top Left"
                                      }),
                                      _createVNode(_component_el_option, {
                                        value: "bottomLeft",
                                        label: "Bottom Left"
                                      }),
                                      _createVNode(_component_el_option, {
                                        value: "topRight",
                                        label: "Top Right"
                                      }),
                                      _createVNode(_component_el_option, {
                                        value: "bottomRight",
                                        label: "Bottom Right"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_el_divider)
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _hoisted_64,
                          _createVNode(_component_el_form_item, {
                            label: "Logging Level",
                            "data-test": "receiver-details-logging-level-form"
                          }, {
                            label: _withCtx(() => [
                              _hoisted_65
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "mt-2",
                                modelValue: _ctx.receiver.deviceSettings.advanced.loggingLevel,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.receiver.deviceSettings.advanced.loggingLevel) = $event)),
                                placeholder: "Select logging level",
                                "data-test": "receiver-details-logging-level-dropdown"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "verbose",
                                    label: "Verbose"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "debug",
                                    label: "Debug"
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "info",
                                    label: "Normal"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          (_ctx.isPlatform('windows') && _ctx.isVersionLessThan(2,0,0))
                            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", null, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.receiver.deviceSettings.advanced.useClassicRenderer,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.receiver.deviceSettings.advanced.useClassicRenderer) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_66
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ( _ctx.isPlatform('windows') && _ctx.isVersionLessThan(2,0,0))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _hoisted_68,
                                _createVNode(_component_el_form_item, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("label", null, [
                                      _createVNode(_component_el_switch, {
                                        modelValue: _ctx.receiver.deviceSettings.advanced.airplayEnabled,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.receiver.deviceSettings.advanced.airplayEnabled) = $event))
                                      }, null, 8, ["modelValue"]),
                                      _hoisted_69
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("label", null, [
                                      _createVNode(_component_el_switch, {
                                        modelValue: _ctx.receiver.deviceSettings.advanced.castEnabled,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.receiver.deviceSettings.advanced.castEnabled) = $event))
                                      }, null, 8, ["modelValue"]),
                                      _hoisted_70
                                    ])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.isPlatform('windows'))
                                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("label", null, [
                                          _createVNode(_component_el_switch, {
                                            modelValue: _ctx.receiver.deviceSettings.advanced.miracastEnabled,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.receiver.deviceSettings.advanced.miracastEnabled) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _hoisted_71
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.activeRoom)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                disabled: "true",
                name: "status"
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_popover, {
                    "popper-class": "is-dark",
                    placement: "bottom-start",
                    trigger: _ctx.windowWidth.value >= 576 ? 'hover' : 'click',
                    width: 300
                  }, {
                    reference: _withCtx(() => [
                      (_ctx.windowWidth.value >= 576)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.allReceiverStatus.toLowerCase()}`)
                          }, [
                            (_ctx.allReceiverStatus.toLowerCase() != 'legacy')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_ctx.allReceiverStatus.toLowerCase()), 1))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_76, [
                                  _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_77)
                                ]))
                          ], 2))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(`ms-auto align-self-center receiver-status__badge__mobile receiver-status__badge__mobile--${_ctx.allReceiverStatus.toLowerCase()}`),
                            "aria-hidden": "true"
                          }, null, 2))
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        (_ctx.allReceiverStatus.toLowerCase() != 'legacy')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Receiver status is " + _toDisplayString(_ctx.allReceiverStatus.toLowerCase()) + ". ", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_73, "Legacy receivers do not support receiver status. ")),
                        _hoisted_74
                      ])
                    ]),
                    _: 1
                  }, 8, ["trigger"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])
    ])), [
      [_directive_loading, _ctx.viewLoading]
    ])
  ])), [
    [_directive_loading, _ctx.viewLoading]
  ])
}